import { mutationOptions } from "@/common/mutations/mutationOptions";

const pushNotificationsModule =
	import.meta.env.VITE_CAPACITOR_BUILD === "true"
		? import("@capacitor/push-notifications")
		: null;

export function buildPushNotificationsRegisterMutation() {
	return mutationOptions({
		mutationKey: ["capacitor-push-notifications-register"],
		mutationFn: () =>
			pushNotificationsModule
				? pushNotificationsModule.then((m) => m.PushNotifications.register())
				: Promise.reject(new Error("Push notifications are not supported")),
		networkMode: "always",
	});
}
